import type { InboxConversationListProps } from '../CentralInbox.types';

import { Typography } from '@recruit-robin/robin-theme/web-components';
import { CommunicationChannelsWarning } from 'components/ui/molecules/CommunicationChannelsWarning';
import { useCommunicationChannelsStatus } from 'hooks/shared/useCommunicationChannelsStatus';
import { usePageContext } from 'hooks/shared/usePageContext';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { useContext, useState } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useInboxStore } from 'stores/inbox/inbox.store';
import { useStyles } from './InboxConversationList.styles';
import { InboxConversationListBody } from './InboxConversationListBody/InboxConversationListBody';
import { InboxConversationListFilters } from './InboxConversationListFilters/InboxConversationListFilters';
import { InboxConversationListHeader } from './InboxConversationListHeader/InboxConversationListHeader';
import { InboxConversationListSkeleton } from './InboxConversationListSkeleton/InboxConversationListSkeleton';

export const InboxConversationList = ({
  showTeamView = true,
  showFilters = true,
  conversations = [],
  isLoading = true,
}: InboxConversationListProps) => {
  const isSidebarExpanded = useInboxStore((s) => s.isSidebarOpened);
  const pageContext = usePageContext();
  const classes = useStyles({ isSidebarExpanded, pageContext });
  const { dictionary } = useContext(LocalizationContext);

  const channelsStatus = useCommunicationChannelsStatus();
  const [showWarning, setShowWarning] = useState(channelsStatus.hasDisconnectedChannels);

  const handleCloseWarning = () => {
    setShowWarning(false);
  };

  return (
    <div css={classes.root}>
      <div css={classes.headerPadding}>
        <InboxConversationListHeader showTeamView={showTeamView} />
      </div>
      <div css={classes.divider} />
      {showFilters && (
        <div css={classes.contentPadding}>
          <InboxConversationListFilters />
        </div>
      )}
      {showWarning && channelsStatus.hasDisconnectedChannels && pageContext === PageContext.CentralInbox && (
        <CommunicationChannelsWarning onClose={handleCloseWarning} />
      )}
      {isLoading ? (
        <InboxConversationListSkeleton />
      ) : conversations.length > 0 ? (
        <InboxConversationListBody conversations={conversations} />
      ) : (
        <div css={classes.flexAlignment}>
          <Typography variant={(v) => v.heading[5]} color={(v) => v.neutral.gray[50]}>
            {dictionary.emptyConversations}
          </Typography>
        </div>
      )}
    </div>
  );
};
